import { render, staticRenderFns } from "./InputValidation.vue?vue&type=template&id=40920f2d"
import script from "./InputValidation.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputValidation.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports